module.exports = __webpack_public_path__ + "img/dex.b09291e7.svg";